// VEDNOR SCRIPTS
import gsap from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { Flip } from "gsap/Flip";
import barba from '@barba/core';
import Swiper, {FreeMode, Parallax, Navigation, Pagination, Thumbs, EffectFade, Autoplay} from 'swiper';
import imagesLoaded from 'imagesloaded';

// MODULES
import { barbaBeforeEnterFunctions } from './modules/barba-beforeEnter';
import { barbaAfterFunctions } from './modules/barba-after';
import { barbaAfterEnterFunctions } from './modules/barba-afterEnter';
import { header } from './modules/header';
import { nav } from './modules/nav';
import { init } from './modules/init';

// PAGES
import { aboutPage } from './pages/about-page';
import { careersPage } from './pages/careers-page';
import { solutionSingle } from "./pages/solution-single";
import { whowehelpSingle } from "./pages/whowehelp-single";
import { platformPage } from "./pages/platform-page";
import { csSingle } from "./pages/case-study-single";
import { contactPage } from './pages/contact-page';
import { dataPage } from './pages/data-page';
import { landingPages } from "./pages/landing-pages";
import { personaPages } from "./pages/persona-pages";
//import { resourcesPage } from "./pages/resources-page";
import { blogPage } from "./pages/blog-page";
import { jobsPage } from "./pages/jobs-page";
import { jobPage } from "./pages/job-single";
import { page404 } from "./pages/page-404";
import { ccpaSubmit } from "./pages/ccpa";
import { optOut } from "./pages/opt-out";
import { pageBuilder } from "./pages/page-builder";
import { barbaBeforeLeaveFunctions } from "./modules/barba-beforeLeave";
import { homePage } from "./pages/home-page";
import { eventsSingle } from "./pages/events-single";
import { howWeHirePage } from "./pages/how-we-hire-page";
import { devPlatform } from "./pages/dev-platform";
import { pressPage } from "./pages/press-page";
import { marchMadnessFunctions } from "./pages/march-madness";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrambleTextPlugin, DrawSVGPlugin, Draggable, MotionPathPlugin, Flip);

// Global smoother instance
let smoother;

(function($, window, document) {
	
	const $body = $('body');
	
	/***************************************************************
		*
		LISTEN FOR JQUERY DOM READY
		*
	***************************************************************/

	$(function() {
		
		/***************************************************************
			Functions to run only once (Not on every page transition)
		***************************************************************/
		
		// Prevents transitions from animating on initial load
		$body.removeClass("preload");
		
		// Setup smooth scrolling
		smoother = ScrollSmoother.create({
			wrapper: "#smooth-wrapper",
			content: "#smooth-content",
			smooth: 1.5,
			effects: true,
			normalizeScroll: false,
			autoResize: false,
			ignoreMobileResize: true
			//smoothTouch: 0.00000001
		});
		
		function fixClicks(smoother) {
			let paused = smoother.paused,
				wasDragging, observer,
				ignore = e => wasDragging && e.preventDefault();
			smoother.paused = value => {
				if (value) {
					observer = ScrollTrigger.observe({
						type: "touch",
						capture: true,
						onRelease(self, dragging) {
							wasDragging = dragging;
						}
					});
					smoother.content().addEventListener("click", ignore, {capture: true});
				} else {
					observer && observer.kill();
					wasDragging = false;
					smoother.content().removeEventListener("click", ignore, true);
				}
				paused.call(smoother, value);
			};
		}
		
		fixClicks(smoother);
		
		ScrollTrigger.addEventListener("scrollStart", function() {
			$body.addClass("disable-hover");
		});
		ScrollTrigger.addEventListener("scrollEnd", function() {
			$body.removeClass("disable-hover");
		});
		
		// Setup isScrolling variable
		//var isScrolling;
		//var navScroll = $('.menu-main-menu-container');
		//// Listen for scroll events
		//navScroll.on('scroll', function (event) {
		//  $('.menu-main-menu-container a').css('pointer-events', 'none');
		//  // Clear our timeout throughout the scroll
		//  clearTimeout( isScrolling );
		//  // Set a timeout to run after scrolling ends
		//  isScrolling = setTimeout(function() {
		//    // Run the callback
		//    $('.menu-main-menu-container a').css('pointer-events', '');
		//  }, 300);
		//})
		
		let mm = gsap.matchMedia();
				
		//Nav functions
		nav(smoother);
		
		$(document).on('gform_post_render', function(event, form_id, current_page){
			ScrollTrigger.refresh(true);
		});
		
		//$(document).on("gform_confirmation_loaded", function (e, form_id) {
		//  console.log('submitted');
		//  ScrollTrigger.refresh(true);
		//});
		
		function loadCSS(url) {
			const link = document.createElement('link');
			const domain = 'https://' + window.location.hostname + '/wp-content/themes/va2022/assets/dist/css/';
			const timestamp = new Date().getTime();
			link.rel = 'stylesheet';
			link.href = domain + url + '?v=' + timestamp;
			document.head.appendChild(link);
		}
		
		function unloadCSS(url) {
			const domain = 'https://' + window.location.hostname + '/wp-content/themes/va2022/assets/dist/css/';
			const links = document.querySelectorAll(`link[href^="${domain + url}"]`);
			links.forEach(link => {
				if (link) {
					link.remove();
				}
			});
		}
				
		/***************************************************************
			Functions to run initially and again on each page transition
		***************************************************************/
	 
		init(gsap, mm, ScrollTrigger, smoother, Draggable, Swiper, FreeMode, Navigation, Thumbs, EffectFade, Autoplay);
		
		/***************************************************************
			BarbaJS Setup
		***************************************************************/

		barba.init({
			debug: false,
			transitions: [
				{
					name: 'opacity-transition',
					sync: true,
					beforeLeave(data) {
						const done = this.async();
						smoother.paused(true);
						gsap.to(data.current.container, {duration: 0.6, autoAlpha: 0, onComplete: done});
				},
					enter() {
						smoother.paused(false);
						smoother.scrollTo(0, false);
				},
					afterEnter(data) {
						gsap.from(data.next.container, {delay: 0.5, duration: 0.6, opacity: 0});
						ScrollTrigger.refresh(true);
				},
					after() {
						ScrollTrigger.refresh(true);
					}
				},
			],
			views: [
				{
					namespace: 'march-madness',
					beforeEnter() {
						//if (!document.querySelector('link[rel="stylesheet"][href*="marchMadness.css"]')) {
						//	loadCSS('marchMadness.css');
						//}
					},
					afterEnter() {
						if (smoother) {
							smoother.kill();
						}
					},
					beforeLeave() {
						smoother = ScrollSmoother.create({
							wrapper: "#smooth-wrapper",
							content: "#smooth-content",
							smooth: 1.5,
							effects: true,
							normalizeScroll: false,
							autoResize: false,
							ignoreMobileResize: true
						});
						fixClicks(smoother);
						ScrollTrigger.refresh(true);
					},
					//afterLeave() {
					//	unloadCSS('marchMadness.css');
					//}
				}
			]
		});
		
		barba.hooks.beforeLeave((data) => {
			barbaBeforeLeaveFunctions(data);
		});
		
		barba.hooks.beforeEnter((data) => {
			barbaBeforeEnterFunctions(data);
		});
		
		barba.hooks.after((data) => {
			barbaAfterFunctions(data);
			init(gsap, mm, ScrollTrigger, smoother, Draggable, Swiper, FreeMode, Navigation, Thumbs, EffectFade, Autoplay);
			fixClicks(smoother);
		});
		
		barba.hooks.afterEnter((data) => {
			// Header functions
			header(gsap, ScrollTrigger);

			barbaAfterEnterFunctions(data, ScrollTrigger, smoother);

			if (data.next.namespace == 'home-page') {
				homePage(barba, gsap, ScrollTrigger, smoother, mm);
			} else if (data.next.namespace == 'about') {
				aboutPage(gsap, DrawSVGPlugin, ScrollTrigger, smoother, Swiper, FreeMode, Parallax, data);
			} else if (data.next.namespace == 'life-at-videoamp') {
				careersPage(gsap, mm, ScrollTrigger, smoother, imagesLoaded, Swiper, Parallax, Navigation, Pagination, FreeMode);
			} else if (data.next.namespace == 'solution') {
				//solutionSingle(data, gsap, mm, ScrollTrigger, smoother);
			} else if (data.next.namespace == 'whowehelp') {
				whowehelpSingle(data, gsap, mm, ScrollTrigger, smoother);
				pageBuilder(data, gsap, mm, smoother, Swiper, Parallax, Navigation, Pagination, FreeMode);
			} else if (data.next.namespace == 'dev-platform') {
				devPlatform(data, gsap, mm, ScrollTrigger, smoother, MotionPathPlugin, DrawSVGPlugin);
			} else if (data.next.namespace == 'platform') {
				platformPage(gsap, mm, ScrollTrigger, smoother);
			} else if (data.next.namespace == 'case-studies') {
				csSingle(gsap, mm, ScrollTrigger, smoother, ScrambleTextPlugin, Swiper, FreeMode, Parallax, Navigation, Pagination);
			} else if (data.next.namespace == 'contact') {
				contactPage(mm, smoother);
			} else if (data.next.namespace == 'data') {
				dataPage(data, gsap, mm, smoother, ScrollTrigger);
			} else if (data.next.namespace == 'valid') {
				dataPage(data, gsap, mm, smoother, ScrollTrigger);
			} else if (data.next.namespace == 'landing-page') {
				landingPages(data, gsap, mm, smoother, Swiper, Parallax, Navigation, Pagination, FreeMode, ScrollTrigger);
			} else if (data.next.namespace.match('persona')) {
				personaPages(gsap, mm, ScrollTrigger, smoother, imagesLoaded, Swiper, Parallax, Navigation, Pagination, FreeMode);
			} else if (data.next.namespace == 'blog') {
				blogPage(data, mm, smoother);
			} else if (data.next.namespace == 'jobs') {
				jobsPage(gsap, smoother, ScrollTrigger);
			} else if (data.next.namespace == 'how-we-hire') {
				howWeHirePage(gsap, mm, ScrollTrigger, Pagination, smoother);
			} else if (data.next.namespace == 'job') {
				jobPage(ScrollTrigger, smoother);
			} else if (data.next.namespace == 'notfound') {
				page404();
			} else if (data.next.namespace == 'ccpa-web-form') {
				//ccpaSubmit(data);
				console.log('PRIVACY RIGHTS REQUEST WEB FORM');
			} else if (data.next.namespace == 'opt-out' || data.next.namespace == 'your-privacy-choices') {
				optOut();
			} else if (data.next.namespace == 'custom') {
				pageBuilder(data, gsap, mm, smoother, Swiper, Parallax, Navigation, Pagination, FreeMode, ScrollTrigger, barba);
			} else if (data.next.namespace == 'events') {
				eventsSingle();
				pageBuilder(data, gsap, mm, smoother, Swiper, Parallax, Navigation, Pagination, FreeMode);
			} else if (data.next.namespace == 'newsroom') {
				pressPage(ScrollTrigger, Swiper, Navigation);
			} else if (data.next.namespace == 'march-madness') {
				marchMadnessFunctions(gsap, mm, ScrollTrigger, DrawSVGPlugin, barba, Flip, data);
			}
		});
		
		//$('.barba-link').each(function() {
			
		//  const $this = $(this);
		//  const domain = 'https://' + window.location.hostname;
		//  const $href = $this.data('href');
		//  const url = $href.replace(domain, '');
		//  console.log(url);
		//  $this.on('click', function() {
		//    smoother.paused(false);
		//    $('html, body').removeClass('superlock');
		//    barba.go(url);
		//  });
						
		//});
		
		
	});

})(window.jQuery, window, document);